














































































































































































import type { PropType } from "vue"
import type { stadium_info } from "@/@types/stadium/stadium"
import { Vue } from "vue-property-decorator"
import moment from "moment"
import AreaPicker from '@/components/areapicker.vue'

export default Vue.extend({
  name: "StadiumInfoForm",
  components: { AreaPicker },
  props: {
    id      : { type: String, required: true },
    button  : { type: Boolean, default: true },
    editable: { type: Boolean, required: true },
    form    : { type: Object as PropType<stadium_info> },
    correct : { type: Object, default() { return {} } },
    show    : { type: Object,
      default() {
        return {
          all               : true,
          name              : true,
          area              : true,
          addr              : true,
          rent_run_years    : true,
          rent_surplus_years: true,
          open_time         : true,
          rent_type         : true,
          stadium_size      : true,
          ground_count      : true,
          other_item        : true,
          other_size        : true,
        }
      }
    },
  },
  data() {
    return {
      area  : [] as string[],
      time  : null as moment.Moment | null,
      data  : {} as stadium_info,
      change: {} as any,
      rules : {
        name              : { required: true, message: "场馆名称不能为空", trigger: "blur" },
        province_id       : { required: true, message: "场馆地区不能为空", trigger: "blur" },
        addr              : { required: true, message: "详细地址不能为空", trigger: "blur" },
        open_time         : { required: true, message: "场馆开业时间不能为空", trigger: "blur" },
        rent_run_years    : { required: true, message: "场馆已经营年限不能为空", trigger: "blur" },
        rent_surplus_years: { required: true, message: "场馆租赁剩余年限不能为空", trigger: "blur" },
        rent_type         : { required: true, message: "场馆租赁续签情况不能为空", trigger: "blur" },
        stadium_size      : { required: true, message: "场馆总面积不能为空", trigger: "blur" },
        ground_count      : { required: true, message: "羽毛球片场数不能为空", trigger: "blur" },
      },
    }
  },
  computed: {
    if_correct() {
      return (key: string): string => {
        let is_correct = ""
        if (Object.prototype.hasOwnProperty.call(this.form, key) && Object.prototype.hasOwnProperty.call(this.change, key)) {
          if (this.change.id && this.change.id > 0) is_correct = ""
          else is_correct = "is_correct"
        }
        return is_correct
      }
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        this.area   = [String(this.form.province_id.padEnd(6, "0")), String(this.form.city_id.padEnd(6, "0")), String(this.form.county_id)]
        this.time   = moment(this.form.open_time, "YYYY-MM-DD")
        this.data   = this.$deep_copy(this.form)
        this.change = this.$deep_copy(this.correct)
      })
    },
    show_correct(key: string): boolean {
      let correct = false
      if (Object.prototype.hasOwnProperty.call(this.form, key) && Object.prototype.hasOwnProperty.call(this.change, key)) {
        if (this.change.id && this.change.id > 0) correct = true
        else correct = false
      }
      return correct
    },
    choose_area(value: string[], options: any) {
      this.data.province_id = value[0] as string
      this.data.city_id     = value[1] as string
      this.data.county_id   = value[2] as string
      let area = ""
      for (const option of options) area += `${option.label}`
      this.data.area_name = area
    },
    /* 修改续约状态 */
    change_rent_type(type: string) {
      this.data.rent_type = type
    },
    submit() {
      if (this.time) this.data.open_time = this.time.format("YYYY-MM-DD")
      const form = this.$refs.form as any
      const params = this.$deep_copy(this.data)
      form.validate((valid: boolean) => {
        if (valid) {
          params.estimate_id = this.id
          this.$emit("modify", params)
        }
      })
    },
    check(): boolean {
      let checked = false
      const form = this.$refs.form as any
      form.validate((valid: boolean) => {
        checked = valid
      })
      return checked
    },
  },
  watch: {
    time(val: moment.Moment) {
      if (val) this.data.open_time = val.format("YYYY-MM-DD")
    },
    data: {
      handler() {
        this.$nextTick(() => {
          if (!this.correct.id) this.submit()
          this.change = this.$deep_copy(this.correct)
        })
      },
      deep   : true
    }
  }
})
